var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"headline"},[_vm._v("Velkommen "+_vm._s(_vm.user.first_name))]),_c('div',{staticClass:"subtitle-1 light-grey"},[_vm._v("Oversigt over nuværende måned")]),_c('br'),_c('moderator-dashboard-tabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }